import type { TopicProgressV2 } from './types'

export const SEED_INTERVALS = [2, 7, 21]
export const MASTER_SCORE = 70
export const MASTER_INTERVAL = 21

export function todayISO(d: Date = new Date()): string {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export function addDaysISO(iso: string, days: number): string {
  const d = new Date(iso + 'T12:00:00')
  d.setDate(d.getDate() + days)
  return todayISO(d)
}

export function nextRep(
  p: Pick<TopicProgressV2, 'interval_days' | 'misses' | 'state'>,
  score: number
): Pick<TopicProgressV2, 'interval_days' | 'next_rep_at' | 'state' | 'misses' | 'last_score'> {
  const today = todayISO()
  let interval: number
  let misses = p.misses
  if (score < MASTER_SCORE) {
    interval = 2
    misses += 1
  } else if (score >= 90) {
    interval = Math.max(2, Math.round((p.interval_days || 2) * 1.6))
  } else {
    const cur = p.interval_days || 0
    const next = SEED_INTERVALS.find((s) => s > cur)
    interval = next ?? Math.round(cur * 1.3)
  }
  const state = interval >= MASTER_INTERVAL && score >= MASTER_SCORE ? 'oturdu' : 'active'
  return {
    interval_days: interval,
    next_rep_at: addDaysISO(today, interval),
    state,
    misses,
    last_score: score,
  }
}

export function seedTopic(key: string): TopicProgressV2 {
  return {
    topic_key: key,
    state: 'active',
    interval_days: 2,
    next_rep_at: addDaysISO(todayISO(), 2),
    last_score: null,
    misses: 0,
  }
}

export function isDue(t: TopicProgressV2, today: string = todayISO()): boolean {
  return t.state === 'active' && t.next_rep_at <= today
}

export function dueTopics(list: TopicProgressV2[], today: string = todayISO()): TopicProgressV2[] {
  return list.filter((t) => isDue(t, today)).sort((a, b) => a.next_rep_at.localeCompare(b.next_rep_at))
}
